import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isCollapsedSubject = new BehaviorSubject<boolean>(true);
  isCollapsed$ = this.isCollapsedSubject.asObservable();

  setCollapsedState(isCollapsed: boolean) {
    this.isCollapsedSubject.next(isCollapsed);
  }

  toggle() {
    this.isCollapsedSubject.next(!this.isCollapsedSubject.value);
  }
}
